/** Friendly "not yet activated" screen used to gate portal sections. */
import { useTranslation } from "react-i18next";
import { Hourglass } from "@phosphor-icons/react";

export default function AccessLockedScreen({
  titleKey,
  messageKey,
  testId = "access-locked",
}) {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className="rounded-3xl border border-dashed border-slate-300 bg-white/60 px-6 py-16 text-center"
    >
      <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 mb-5">
        <Hourglass size={24} weight="regular" className="text-slate-500" />
      </span>
      <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">
        {t(titleKey)}
      </h2>
      <p className="mt-3 max-w-md mx-auto text-sm leading-relaxed text-slate-600">
        {t(messageKey)}
      </p>
    </div>
  );
}
